import React from 'react';

import './styles.css'

function Footer() {
  return (
    <footer>
      <p> Com ❤ Matheus Oliveira Santos</p>
    </footer>
  );
}

export default Footer;